import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

export const useConfig = () => {
  const globalConfig = useMapGetter('globalConfig/get');

  const isEnterprise = computed(() => {
    return true; // FORCE ENTERPRISE
  });

  const isSelfHosted = computed(() => {
    return true; // FORCE SELF HOSTED
  });

  const isOnChatwootCloud = computed(() => {
    return false; // FORCE NOT CLOUD
  });

  const enterprisePlanName = computed(() => {
    return 'enterprise'; // FORCE ENTERPRISE PLAN NAME
  });

  const allowedLoginMethods = computed(() => {
    // FORCE ENABLE SAML
    const methods = globalConfig.value.allowedLoginMethods || ['email'];
    if (!methods.includes('saml')) {
      methods.push('saml');
    }
    return methods;
  });

  const chatwootVersion = computed(() => globalConfig.value.chatwootVersion);

  return {
    isEnterprise,
    isSelfHosted,
    isOnChatwootCloud,
    enterprisePlanName,
    allowedLoginMethods,
    chatwootVersion,
  };
};
